import React, {
    useContext,
} from "react"

import {
    Context,
} from "../../../Model/Contexts/AppContext"

import "./style.css"

const EMETLFooter = () => {

    const {
        _mode,
    } = useContext(Context)

    return (
        <div>
            <footer className="footer">
                <div className="container footerLinkWrapper">
                    <div className="row">
                        <a className="footerLink col" href="Terms">Terms of Use</a>
                        <a className="footerLink col" href="Feedback">Feedback</a>
                        <a className="footerLink col" href="AccountHelp">Account Help</a>
                        <a className="footerLink col" href="Cogent">Cogent Security</a>
                    </div>
                    <div className="row">
                        <a className="footerLink col" href="About">About</a>
                        <a className="footerLink col" href="ContactUs">Contact Us</a>
                        <a className="footerLink col" href="Investors">Investors</a>
                        <a className="footerLink col" href="Announcements">Announcements</a>
                    </div>
                </div>
            </footer>
            <footer 
                className="copyrightBar"
            >
                &copy;{(new Date().getFullYear())} emetl.com
            </footer>
        </div>
    )
}

export default EMETLFooter
